import React from "react";
import { useTranslation } from "react-i18next";
var Leyend = function (_a) {
    var showLeyend = _a.showLeyend;
    var t = useTranslation().t;
    if (!showLeyend)
        return null;
    return (React.createElement("div", { className: "leyend" },
        React.createElement("div", { className: "leyend__container" },
            React.createElement("div", { className: "leyend__header" },
                React.createElement("span", null, t("alert")),
                React.createElement("img", { src: "./images/provident.svg", alt: "logo maat", width: 55, height: 31 })),
            React.createElement("div", { className: "leyend__body" },
                React.createElement("div", { className: "leyend__body-img" },
                    React.createElement("img", { src: "./images/matilda_noti.svg", alt: "logo-company" })),
                React.createElement("div", { className: "leyend__body-text" },
                    React.createElement("span", null, t("liveness-check-used-for-loan")))))));
};
export default Leyend;
